import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { withAlertHandler } from 'entoro-shared';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import {
  apolloClient,
  offerRequestInformationMutation,
} from '../../../../apollo';
const MySwal = withReactContent(Swal);

const NotifyBanker = ({ offerId, client }) => {
  const variables = {
    offerId,
    message: '',
  };

  const { mutate } = client;

  const handleNotifyBanker = () => {
    return MySwal.fire({
      title: 'Thank you for your interest',
      text: ' A banker will contact you shortly',
      icon: 'success',
      confirmButtonColor: '#808080',
      allowOutsideClick: false,
      cancelButtonColor: '#d33',
      showCancelButton: false,
      confirmButtonText: `Continue`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        //send banker notification
        try {
          const { data } = await mutate({
            mutation: offerRequestInformationMutation,
            variables,
          });
        } catch (error) {
          console.log(`error`, error);
        }
      }
    });
  };
  return (
    <button
      style={{ textDecoration: 'none', width: 'inherit' }}
      className='button small w-button'
      onClick={handleNotifyBanker}
    >
      {'Start Investment'}
    </button>
  );
};
export default connect()(withApollo(NotifyBanker));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/NotifyBanker/index.js